import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { SessionCutoffModelPopComponent } from '../session-cutoff-model-pop/session-cutoff-model-pop.component';
import { PageEvent } from '@angular/material/paginator';


@Component({
  selector: 'app-session-cutoff',
  templateUrl: './session-cutoff.component.html',
  styleUrls: ['./session-cutoff.component.scss']
})
export class SessionCutoffComponent implements OnInit {
  SessionCutOff: FormGroup;
  SessionCutOffList: any[];
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder, public router: Router, private dialog: MatDialog,
    private route: ActivatedRoute) {
  }

  utp: any;
  sessCreate = true;
  sessUpdate = true;
  dialogRef: MatDialogRef<any>;
   userPermission: any;
  UserCollege
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    window.scroll(0, 0);
    this.SessionCutOff = this.fb.group({
      SearchString: new FormControl(''),
    });
    this.fetchAllSessionCutoff();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.fetchAllSessionCutoff();
  }

  fetchAllSessionCutoff() {
    this.spinner.show();
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['SearchString'] = this.SessionCutOff.value.SearchString;
    this.umsService.listSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SessionCutOffList = res.data;
        this.totalItems = res.data[0].RecordCount;
      } else {
        this.SessionCutOffList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.SessionCutOffList = [];
      let temp = this.SessionCutOff.value;
      let payload = {}
      payload['PageSize'] = this.pageSize;
      payload['SearchString'] = temp['SearchString'];
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.listSessionCutOff(payload).subscribe(res => {
        if (res.status) {
          this.SessionCutOffList = res.data;
          this.totalItems = res.data[0].RecordCount;
        } else {
          this.SessionCutOffList = [];
        }
      }, (ERROR: HttpErrorResponse) => {
        this.SessionCutOffList = [];
      });
    },1000)
   
  }

  prepopulateRecord(e) {
    const dialogRef = this.dialog.open(SessionCutoffModelPopComponent, {
      width: '100vh',
      data: { key: "Edit", selected: e },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.fetchAllSessionCutoff();
      this.SessionCutOff.controls['SearchString'].setValue('');
    });
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(SessionCutoffModelPopComponent, {
      width: '100vh',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.fetchAllSessionCutoff();
      this.SessionCutOff.controls['SearchString'].setValue('');
    });
  }
}
